import styles from "./PageHeader.module.css";

interface PageHeaderProps {
	title: string;
	subtitle?: string;
	action?: React.ReactNode;
}

export function PageHeader({ title, subtitle, action }: PageHeaderProps) {
	return (
		<div className={styles.wrapper}>
			<div>
				<h1 className={styles.title}>{title}</h1>
				{subtitle && <p className={styles.subtitle}>{subtitle}</p>}
			</div>
			{action && <div className={styles.action}>{action}</div>}
		</div>
	);
}
